/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

export class SanGameAssets {
    

    public static NEW_INTRO_BACKGROUND_PLATE =  "resources/images/intro/newIntroBackgroundPlate.png";
    public static INTRO_BORDER_TILE =  "resources/images/intro/borderTile.png";
    public static FEATURE_1 =  "resources/images/intro/Splash_PrisonBreak.png";
    public static FEATURE_2 =  "resources/images/intro/Splash_XWays.png";
    public static FEATURE_3 =  "resources/images/intro/Splash_Wild.png";
    public static INTRO_LOGO =  "resources/images/intro/logo.png";
    public static NOLIMIT_BONUS_ANIMATION =  "resources/images/intro/NolimitBonusAnimation.json";
    public static INTRO_BUY_FEATURE_ICON =  "resources/images/intro/buyFeatureIcon.svg";
    // public static PROMO_FREESPIN =  "nolimit/promo-panel/FREESPIN.png";
    public static MAIN_GAME_BACKGROUND:string = "mainBackground";

    public static INTRO_BACKGROUND:string = "resources/images/intro/introBackground.jpg";

    public static NORMAL_REEL_DIVIDER:string = "reelDivider";
    public static NEAR_WIN_REEL_DIVIDER:string = "reelDividerNearWin";


    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("numbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt")
                ]
            },
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json")
                ],
                animations : {
                    "introLogo" : "introLogo"
                }
            }, 
            {
                name : "introJpeg",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("introJpeg0", "sheets/introJpeg/introJpeg0.json")
                ],
                animations : {
                    "introBackground" : "introBackground"
                }
            }
        ],
        main : [
            {
                name : "freespin",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json")
                ],
                animations : {}
            }, 
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                ],
                animations : {
                    "reelDivider" : "ui/reelDividers/div",
                    "reelDividerNearWin" : "ui/reelDividers/div-attention",
                    "benchDude" : "Idle_Loops/Bench/L_Bench_",
                    "walkingDude" : "Idle_Loops/Walking/L_Walking_",
                    "Lever" : "X_Ways_Switch/Switch_",
                    "XMelt" : "X_Ways_Melt/Melt_",
                    "Frame_Win_2" : "Frame_Win_2/Win_2_",
                    "Frame_Win_4" : "Frame_Win_4/Win_4_",
                    "Frame_Toggle_1" : "Frame_Toggle_1/Toggle1_",
                    "Frame_Toggle_2" : "Frame_Toggle_2/Toggle2_",
                    "Frame_Toggle_4" : "Frame_Toggle_4/Toggle4_",
                    "XpandSingle" : "X_Ways_Melt_Single/Melt_SIngle_",
                }
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                    new TextureAsset("mainJpeg11", "sheets/mainJpeg/mainJpeg11.json"),
                    new TextureAsset("mainJpeg12", "sheets/mainJpeg/mainJpeg12.json")
                ],
                animations : {
                    "mainBackground" : "mainBackground",
                    "W2_Win" : "Wild_2_Win/W_2_WIN_",
                    "W4_Win" : "Wild_4_Win/W_4_WIN_",
                    "Win_Xplod_A":"Win_Xplod_A/Xplod_A_",
                    "Win_Xplod_B":"Win_Xplod_B/Xplod_B_",
                    "XElectro" : "X_Ways_Electro/Electro_",
                    "S_W_T" : "Bonus/Bonus_2_Wild/Bonus_2_Wild_",
                    "S_W_A" : "Bonus/Bonus_Attention/Bonus_Attention_",
                    "S_W_E" : "Bonus/Bonus_2_Wild_End/Bonus_2_Wild_End_",
                    "S_W_A_T" : "Bonus/Bonus_2_Wild_Red/Bonus_2_Wild_RED_",
                    "S_W_A_E" : "Bonus/Bonus_2_J_Wild/Bonus_2_JW_",
                    "Blink_Bar" : "Blink_Block/Blink_Block_",

                    "Blink_Bar_Medium" : "Blink_Block",
                    "Blink_Bar_Tiny" : "Blink_Block_Tiny",
                    "Blink_Bar_Small" : "Blink_Block_Small",
                    "Blink_Bar_High" : "Blink_Block_Large",
                    "Logo_FX_1" : "Logo_Fx/Logo_Fx_",
                    "Logo_FX_2" : "Logo_Fx_2/Logo_Fx_2_",
                    "Dirr_Attention" : "Bonus_Reel_Attention/Reel_Att_",
                    "Block_Landing" : "Block_Landing/Block_Landing_",
                    "W_Split_Land" : "W_Split_Land/W_Split_Land_",
                    "W_Split_Win" : "W_Split_Win/W_4_WIN_",
                    "FlyBy_Spin" : "FlyBy/Loop/FlyBy_Loop_",
                    "FlyBy_Land" : "FlyBy/Land/FlyByLand_",
                    "JW_Landing" : "JW_Landing/JW_Landing_",
                    "X_Ways_Landing" : "X_Ways_Landing/X_Ways_Landing_",
                    "Hot_Zone" : "Hot_Zone/Hot_Zone_",
                    "JW_Reveal" : "JW_Reveal/JW_Reveal_",
                    "JW_Idle" : "JW_Idle/JW_Idle_",
                    "Reels_Landing" : "Reels_Landing/Reels_Land_",

                    "JW_Indicator_Light" : "JW_Indicator_Light/JW_Indicator_Light_",
                    "Toapapper" : "Toapapper/Paper_Roll_",
                    
                    "Mystery_Explode" : "Mystery_Explode/M_Explode_",

                    "FIYA" : "FIYA/FIYA_"
                    
                }
            },
            {
                name : "symbolsHigh",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsHigh0", "sheets/symbolsHigh/symbolsHigh0.json")
                ]
            },
            {
                name : "symbols",
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ]
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("No_Win", "spine/No_Win.json"),
                    new SpineAsset("Sym_Win", "spine/Sym_Win.json"),
                    new SpineAsset("skele", "spine/skeleton.json"),
                    new SpineAsset("intro", "spine/Intro.json"),
                    new SpineAsset("bg", "spine/BG.json"),
                    new SpineAsset("bigWin", "spine/Big_Win.json"),
                    new SpineAsset("dudes", "spine/Blocks_Loop.json"),
                    new SpineAsset("fs_Intro", "spine/FS_Intro.json"),
                    new SpineAsset("fs_Intro_Screen", "spine/FS_Intro_Screen.json"),
                    new SpineAsset("FS_Intro_Scratch", "spine/FS_Intro_Scratch.json"),
                    new SpineAsset("Split", "spine/Split.json"),
                    new SpineAsset("FS_Outro_Screen", "spine/FS_Outro_Screen.json"),
                    new SpineAsset("JW_Multi", "spine/JW_Multiplier.json"),
                    new SpineAsset("FS_Reels_Attention", "spine/FS_Reels_Attention.json"),
                    
                ]
            },
        ]
    };
}
